import { initializeApp } from 'firebase/app';
import { getAuth, signInWithRedirect, getRedirectResult, signInWithPopup, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

// online
const firebaseConfig = {
  apiKey: "AIzaSyDVIPX6fEpkfhqOkMya0K6__kLoDnAp_yk",
  authDomain: "virelia-809eb.firebaseapp.com",
  projectId: "virelia-809eb",
  storageBucket: "virelia-809eb.firebasestorage.app",
  messagingSenderId: "47447130523",
  appId: "1:47447130523:web:0e50ba511b2ac78682e13e",
  measurementId: "G-8JZT855RKM"
};

// pre
// const firebaseConfig = {
//   apiKey: "AIzaSyCKEgCi6rdku_HYocf11jcBNGvaNNFBKwk",
//   authDomain: "papibangpre.firebaseapp.com",
//   projectId: "papibangpre",
//   storageBucket: "papibangpre.firebasestorage.app",
//   messagingSenderId: "473132553985",
//   appId: "1:473132553985:web:cc434187e2f337a9fead00",
//   measurementId: "G-VJ5VY5GVEB"
// };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default {
  app,
  auth
};